import React from 'react';
import {padCalendar} from "../../../util";

import "./CorrectiveEvent.css"
import {HeaderDivider} from "../HeaderDivider";
import {ReportSectionHeader} from "../SectionHeader";

const CorrectiveEventComponent = (props) => {
    return <div className={"CorrectiveEventText"}>{props.date}</div>
};

const CaseInformationComponent = (props) => {
    const isCase = props.isCase;

    return <div className={"SubSectionContainer"}>
        <div className={"CorrectiveEventText"}>Ticker: {props.ticker}</div>
        <div className={"CorrectiveEventText"}>Date {isCase ? 'Filed' : 'Commissioned'}: {props.dateCommissioned}</div>
        <div className={"CorrectiveEventText"}>Last Updated: {props.lastUpdated}</div>
    </div>
};

const PeriodInformationComponent = (props) => {

    return <div className={["SubSectionContainer", "CenteredCorrectiveEventText"].join(" ")}>
        <div className={"CorrectiveEventText"}>Start of Class Period: {props.classPeriodStart}</div>
        <div className={"CorrectiveEventText"}>End of Class Period: {props.classPeriodStart}</div>
    </div>
};

const SubSection = (props) => {
    return (
        <div className={"SubSection"}>
            <div className={"CorrectiveEventSubSectionHeader"}>{props.tag}</div>
            <HeaderDivider/>
            {props.children}
        </div>
    );
};


const CorrectiveEventsContainer = (props) => {
    const correctiveEvents = props.correctiveEvents;

    return <React.Fragment>
        <div>
            <ReportSectionHeader>
                <div className={"SectionHeaderInner"}>
                    Case Info
                </div>
                <HeaderDivider/>
            </ReportSectionHeader>

            <div className={"CorrectiveEventContainer"}>
                <SubSection tag={"Commission Information"}>
                    <CaseInformationComponent ticker={props.ticker}
                                              dateCommissioned={padCalendar(props.dateCommissioned)}
                                              lastUpdated={padCalendar(props.lastUpdate)}/>
                </SubSection>
                <SubSection tag={"Class Period"}>
                    <PeriodInformationComponent classPeriodStart={padCalendar(props.classPeriodStart)}
                                                classPeriodEnd={padCalendar(props.classPeriodEnd)}/>
                </SubSection>
                <SubSection tag={"Partial Corrective Events"}>
                    <div className={["SubSectionContainer", "CenteredCorrectiveEventText"].join(" ")}>
                        {
                            correctiveEvents.map((event, index) => {
                                if (index === correctiveEvents.length - 1) {
                                    return null;
                                }
                                return <CorrectiveEventComponent key={index} date={padCalendar(event.date)}/>
                            })
                        }
                    </div>
                </SubSection>
                <SubSection tag={"Final Corrective Event"}>
                    <div className={["SubSectionContainer", "CenteredCorrectiveEventText"].join(" ")}>
                        <CorrectiveEventComponent
                            date={padCalendar(correctiveEvents[correctiveEvents.length - 1].date)}/>
                    </div>
                </SubSection>
            </div>
            <HeaderDivider/>
        </div>
    </React.Fragment>
};


export default CorrectiveEventsContainer;


// WEBPACK FOOTER //
// ./src/common/components/CorrectiveEvent/CorrectiveEventsContainer.js